import { mainFeatures } from '../sidebar/menu-items';
import {
  MunilyPayMenuAccessUser,
  shouldShowMunilyPayTransactionsMenu,
} from './munily-pay-menu-access.constants';

/**
 * Candidatos de la sección Financiera en menú v2.
 * La sección se muestra si al menos uno está presente tras el build (OR en `groupMenuSections`).
 */
export const FINANCIAL_SECTION_FEATURES: readonly string[] = [
  mainFeatures.munilyPayTransactions,
  mainFeatures.munilyPay,
  mainFeatures.accountStatements,
];

/**
 * Estados de cuenta — por edificio (`config.accountState.enable`) o flag global
 * `generalConfig.feature.contability`. Alineado con `AccountsStatusComponent`.
 */
export function shouldShowAccountStatementsMenu(
  contabilityEnabled: boolean,
  accountStateConfig?: { enable?: boolean } | null,
): boolean {
  return !!(accountStateConfig?.enable || contabilityEnabled);
}

/** Munily Pay legacy — `fintech.enable` del edificio + acceso real a `/app/munily-pay/*`. */
export function shouldShowMunilyPayMenuItem(
  user: MunilyPayMenuAccessUser | null | undefined,
  fintechConfig: { enable?: boolean } | null | undefined,
): boolean {
  return shouldShowMunilyPayTransactionsMenu(user, fintechConfig);
}
